import { Ripple, initTE } from "tw-elements"
import "tw-elements"
export interface ButtonProps {
 children: any
 //  submit?: boolean
 color?:
  | "yellow"
  | "white"
  | "lightBrown"
  | "gray"
  | "green"
  | "pink"
  | "blue"
  | "darkBrown"
  | "darkGray"
 size?: "xs" | "sm" | "md" | "lg" | "xl" | "doublexl" | "tableSmallSize"
 onClick?: () => void
 className?: string
 type?: "button" | "submit" | "reset"
}

export const Button = ({
 children,
 color = "yellow",
 //  submit,
 size = "md",
 onClick,
 className = "",
 type,
 ...props
}: ButtonProps) => {
 initTE({ Ripple })
 const sizeClasses = {
  xs: "px-2.5 py-1.5 text-xs rounded",
  sm: "px-3 py-2 text-sm leading-4 rounded-md",
  md: "px-4 py-2 text-sm font-semi rounded-md",
  tableSmallSize: "px-14 py-2 text-sm font-semi rounded-md",
  lg: "px-4 py-2 text-base font-semi rounded-md",
  xl: "px-8 py-3 text-base font-semibold rounded-md",
  doublexl: "px-14 py-3 text-base font-semibold rounded-md",
 }

 const colorClasses = {
  yellow:
   "bg-golden hover:bg-yellow text-black hover:text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:dark-yellow focus:shadow-lg focus:outline-none focus:ring-0 active:dark-yellow active:shadow-lg",
  white:
   "bg-white hover:text-yellow hover:opacity-70 text-black shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:bg-white focus:shadow-lg focus:outline-none focus:ring-0 active:bg-white active:shadow-lg border-[1px] border-light-gray",
  lightBrown:
   "bg-light-brown border border-yellow hover:text-black hover:opacity-70 text-yellow shadow-md transition duration-150 ease-in-out  hover:shadow-lg focus:bg-light-brown focus:shadow-lg focus:outline-none focus:ring-0 active:bg-light-brown active:shadow-lg",
  darkBrown:
   "bg-[#feedac] border border-yellow hover:text-black hover:opacity-70 text-yellow shadow-md transition duration-150 ease-in-out  hover:shadow-lg focus:bg-[#feedac] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#feedac] active:shadow-lg",
  gray:
   "bg-light hover:opacity-70 hover:text-yellow text-black shadow-md transition duration-150 ease-in-out  hover:shadow-lg focus:bg-gray focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray active:shadow-lg border-[1px] border-light-gray",
  green:
   "text-green bg-sea-green border border-sea-green hover:text-black shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:sea-green focus:shadow-lg focus:outline-none focus:ring-0 active:sea-green active:shadow-lg",
  pink:
   "bg-light-pink text-dark-pink border-light-pink border hover:text-black shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:light-pink focus:shadow-lg focus:outline-none focus:ring-0 active:light-pink active:shadow-lg",
  blue:
   "text-[#2B59FF] bg-[#bac9ff] border-light-blue border hover:text-black shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:[#bac9ff] focus:shadow-lg focus:outline-none focus:ring-0 active:[#bac9ff] active:shadow-lg",
  darkGray:
   "bg-[#BEBEBE] hover:opacity-70 hover:text-black text-white shadow-md transition duration-150 ease-in-out  hover:shadow-lg focus:bg-[#BEBEBE] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#BEBEBE] active:shadow-lg border-[1px] border-light-gray",
 }
 return (
  <button
   data-te-ripple-init
   data-te-ripple-color="dark"
   className={` w-full ${sizeClasses[size]} ${colorClasses[color]} ${className}`}
   {...props}
   onClick={onClick}
   type={type}
  >
   {children}
  </button>
 )
}
